"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class CheckBox
 * @description form checkbox component
 */
var React = require("react");
var InputHelper_1 = require("./InputHelper");
var InternalInput_1 = require("./InternalInput");
var util_1 = require("../../../utils/util");
/**
 * OUI checkbox component.
 *
 * @oui-component CheckBox
 */
// for now, we can't extend React.InputHTMLAttributes because HG's version of react types is older and doesn't
// include InputHTMLAttributes, attempting to update HG's react typings resulted in many errors, so we'll need to
// support both versions of the typings for now, this is why we had to specifically add the checked field too.
var CheckBox = function (_a) {
    var label = _a.label, labelledBy = _a.labelledBy, disabled = _a.disabled, checked = _a.checked, defaultChecked = _a.defaultChecked, onBlur = _a.onBlur, fieldName = _a.fieldName, onChange = _a.onChange, inputRef = _a.inputRef, testId = _a.testId, rest = __rest(_a, ["label", "labelledBy", "disabled", "checked", "defaultChecked", "onBlur", "fieldName", "onChange", "inputRef", "testId"]);
    var handleMapFormValue = function (evt) {
        return evt.target.checked;
    };
    return (React.createElement(InputHelper_1.default, { disabled: disabled, value: checked, defaultValue: defaultChecked, fieldName: fieldName, onBlur: onBlur, onChange: onChange, mapFormValue: handleMapFormValue }, function (helper) {
        var describedBy = [helper.hintId, helper.errorId].join(" ").trim();
        var props = __assign({}, rest, util_1.ariaProps({ label: label, labelledBy: labelledBy, describedBy: describedBy }), { disabled: disabled, ref: inputRef, from: "input", type: "checkbox", className: "oui-checkbox oui-react-checkbox", name: helper.fieldName, id: helper.fieldId, checked: helper.value || false, onChange: helper.onChange, onBlur: helper.onBlur, "data-test-id": testId });
        return React.createElement(InternalInput_1.default, __assign({}, props));
    }));
};
exports.default = CheckBox;
//# sourceMappingURL=CheckBox.js.map